import { IRecordsInfo } from "Global/Base/DataSources/Interfaces";
import { BEMClassNameCreator, setupBem } from "Global/Dom/bem";
import { Localization } from "../../../../OW.Remoting/Remoting/Localization";
import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { IContentBuilder } from "./IContentBuilder";
/**
 * Builder, který sestaví dialog pro zobrazení informací o počtu záznamů v seznamu
 * @internal
 */
export class RecordsInfoDialogBuilder implements IContentBuilder {
    private _content: HTMLElement;
    private _info: IRecordsInfo;
    constructor(info: IRecordsInfo) {
        this._info = info;
    }

    private _createRow(block: BEMClassNameCreator, locKey: string, value: number): HTMLElement {
        const row = createElement({ classes: block.element("row") });
        const textSpan = createElement({ type: "span", classes: block.element("row-text") });
        const valueSpan = createElement({ type: "span", classes: block.element("row-value") });
        Localization.addLocData(textSpan, locKey);
        valueSpan.textContent = value.toString();
        row.appendChild(textSpan);
        row.appendChild(valueSpan);
        return row;
    }

    private async _buildMessageElement(): Promise<void> {
        const className = setupBem("records-info-dialog");
        const contentDiv = createElement({ classes: className() });
        contentDiv.appendChild(this._createRow(className, "GUI-702262", this._info.totalCount)); //Počet všech záznamů:
        if (this._info.isFiltered)
            contentDiv.appendChild(this._createRow(className, "GUI-52647", this._info.filteredCount));//Počet záznamů odpovídajících filtru:
        this._content = contentDiv;
    }

    public async build(): Promise<HTMLElement> {
        await this._buildMessageElement();
        return this._content;
    }
}
